import {
  isCombinatorArraySchema,
  isCombinatorObjectSchema,
  isPrimitiveObjectSchema,
} from '@web-config-app/schema-utils';
import { TesterRank } from '@web-config-app/entity-form';
import { rankWith, schemaMatches } from '@jsonforms/core';
import type { AnnotatedJsonSchema } from '@web-config-app/core';

/**
 * array if Object with reference data source control.
 * This is right now just used for Masonry's resolver use case
 * */

export const isArrayObjectReferenceInjectControl = rankWith(
  TesterRank.Highest,
  schemaMatches((schema) => {
    if (schema.type !== 'array' || !schema.items) return false;
    const itemSchema = schema.items as AnnotatedJsonSchema;
    const annotatedSchema = schema as AnnotatedJsonSchema;
    if (
      isCombinatorObjectSchema(itemSchema) ||
      isCombinatorArraySchema(annotatedSchema)
    ) {
      return false;
    }

    return Boolean(
      isPrimitiveObjectSchema(itemSchema) &&
        itemSchema['x-entity-data-source']?.dataSource,
    );
  }),
);
